import { CUSTOMIZED_TILE_ITEM_TYPES, TILE_CARD_VIEW_TYPES } from 'src/consumer/constants'

export function getActivePlanViewType(secondaryItem) {
  const viewToReturn = TILE_CARD_VIEW_TYPES.default
}

export function getCorrectUsableItemType(itemType) {
  return CUSTOMIZED_TILE_ITEM_TYPES[itemType] || itemType
}
